export const UN_SUBSCRIPTION_STATUS = {
  ACTIVE: true,
  INACTIVE: false,
};

export const UN_SUBSCRIPTION_STATUS_MAPPING = {
  [UN_SUBSCRIPTION_STATUS.ACTIVE]: { color: 'green', displayName: 'Active' },
  [UN_SUBSCRIPTION_STATUS.INACTIVE]: {
    color: 'yellow',
    displayName: 'Inactive',
  },
};

export const UN_SUBSCRIPTION_ACTIONS = {
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  INACTIVE: 'in_active',
  ACTIVE: 'active',
  UPDATE: 'update',
};
